import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_MEMORIES_STATE = "memories";

export const memoryCrudStateConfig: CrudConfig = {
  name: "memory",
  path: "seneca/memory/meta/",
  callTypes: [AllowedCallTypes.FETCH_ALL, AllowedCallTypes.CREATE],
  idFieldName: "sectionId"
};
